import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";import Select from "../../Select";
import React from 'react';


import { createStyles } from "./styles";











var BrowsingSelect = function BrowsingSelect(_ref)







{var _context;var id = _ref.id,isPortfolioWithSeveralBc = _ref.isPortfolioWithSeveralBc,isMultiProductPortfolio = _ref.isMultiProductPortfolio,browsingValue = _ref.browsingValue,browsingCriteria = _ref.browsingCriteria,productLineId = _ref.productLineId,changeBrowsingValue = _ref.changeBrowsingValue;
  var classes = createStyles({ isMultiProductPortfolio: isMultiProductPortfolio });
  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    isPortfolioWithSeveralBc ? /*#__PURE__*/
    React.createElement(Select, {
      label: "Choose Browsing Criteria to see correct rates",
      value: browsingValue,
      name: "browsingSelect-".concat(id),
      onChange: changeBrowsingValue,
      className: classes.browsingSelect,
      options: _mapInstanceProperty(_context = _Object$entries(browsingCriteria)).call(_context, function (_ref2) {var _ref3 = _slicedToArray(_ref2, 2),selectValue = _ref3[0],bcInfo = _ref3[1];return {
          value: selectValue,
          label: bcInfo.shortName[productLineId]
        };}) }) : /*#__PURE__*/


    React.createElement("p", { className: classes.singleBrowsingBlock },
    _Object$values(browsingCriteria)[0].shortName[productLineId])));




};

export default BrowsingSelect;
//# sourceMappingURL=index.js.map